import React, { useEffect, useState } from "react";
import "../CityPage/NewCitypage.css"
import { WinnersHeaderBlue } from '../WinnersHome/WinnerBlueLan/WinnersHeaderBlue'
import HomeService from "../../Services/HomeService";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import AdvertisingBanner from "./AdvertisingBanner";
import ExploreTopCities from "./ExploreTopCities";
import LocationInsig from "../WinnersHome/LocationInsig";
import AboutCommunity from "./AboutCommunity";
import ExploreTopCitiesBlue from "./ExploreTopCitiesBlue";
import { WinnersInsightsBlue } from "../WinnersHome/WinnerBlueLan/WinnersInsightsBlue";
import DownloadAppBlue from "../WinnersHome/WinnerBlueLan/DownloadAppBlue";
import DownloadApp from "../WinnersHome/DownloadApp";
import { AlertTriangle } from "lucide-react";

import AOS from "aos";
import "aos/dist/aos.css";


import icon1 from "../../Images/fakec.webp";
import icon2 from "../../Images/u1.webp";
import icon3 from "../../Images/u2.webp";
import icon4 from "../../Images/u3.webp";
import icon5 from "../../Images/u4.png";
import icon6 from "../../Images/u5.png";

import logo from "../../Images/logow.png";


import icon7 from "../../Images/v1.png";
import icon8 from "../../Images/v2.png";
import icon9 from "../../Images/v3.png";
import icon10 from "../../Images/v4.png";
import icon11 from "../../Images/v5.png";
import icon12 from "../../Images/v6.png";

import icon13 from "../../Images/r1.png";
import icon14 from "../../Images/r2.png";

const fallbackIcons = [icon14, icon2, icon3, icon4, icon5, icon6];
const fallbackIcons2 = [icon13, icon8, icon9, icon10, icon11, icon12];
const fallbackIcons3 = [icon10, icon4, icon13, icon14,];
function NewCItypage() {
    const [cityDetails, setCityDetails] = useState({});
    const [reelsForCity, setReelsForCity] = useState([]);
    const location = useLocation();
    const id = location?.state?.id || "";
    const navigate = useNavigate();



    // useEffect(() => {
    //     AOS.init({
    //         duration: 900,
    //         once: false,
    //         mirror: true,
    //         easing: "ease-in-out",
    //         offset: 80,
    //     });
    // }, []);

    // useEffect(() => {
    //     AOS.refreshHard();
    // }, [cityDetails]);

    useEffect(() => {
        AOS.init({
            duration: 900,
            once: false,
            mirror: true,
            easing: "ease-in-out",
            offset: 80,
        });
    }, []);

    useEffect(() => {
        if (cityDetails) {
            AOS.refreshHard();
        }
    }, [cityDetails]);

    const fetchCityDetilsById = async () => {
        try {
            const res = await HomeService.getCityDetailsById(
                // "68720cc572a330fae27b2421"
                id,
            );
            if (res?.status) {
                setCityDetails(res?.data);
            } else {
                // toast.error(res?.message);
                console.log(res?.data);
            }
            console.log("CITY DETAILS", res);
        } catch (error) {
            console.log(error);
        }
    };

    const fetchReelsByCityId = async () => {
        try {
            const res = await HomeService.getReelsByCityId(
                // "68720cc572a330fae27b2421"
                id,
            );
            if (res?.status) {
                setReelsForCity(res?.data);
            } else {
                // toast.error(res?.message);
                console.log(res?.data);
            }
            console.log("REELS DETAILS", res);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchCityDetilsById();
        fetchReelsByCityId();
        window.scroll(0, 0);
    }, [id]);

    const problems = [
        {
            id: 1,
            icon: <i class="fa-solid fa-phone-slash"></i>,
            title: "Problem #1",
            text: "Fake owner numbers that waste time",
        },
        {
            id: 2,
            icon: <i class="fa-solid fa-triangle-exclamation"></i>,
            title: "Problem #2",
            text: "Unverified property listings",
        },
        {
            id: 3,
            icon: <i class="fa-solid fa-xmark"></i>,
            title: "Problem #3",
            text: "Endless & unproductive calls",
        },
        {
            id: 4,
            icon: <i class="fa-solid fa-database"></i>,
            title: "Problem #4",
            text: "Old, worthless data",
        },
        {
            id: 5,
            icon: <i class="fa-solid fa-users"></i>,
            title: "Problem #5",
            text: "Extreme competition",
        },
        {
            id: 6,
            icon: <i class="fa-solid fa-building"></i>,
            title: "Problem #6",
            text: "No direct builder connections",
        },
    ];

    const brokerdata = [
        {
            id: 1,
            icon: <i class="fa-solid fa-phone-slash"></i>,
            title: "Verified Data",
            text: "Real estate data you can trust,verified daily",
        },
        {
            id: 2,
            icon: <i class="fa-solid fa-triangle-exclamation"></i>,
            title: "Fresh Contact",
            text: "Owner contacts updated every single day",
        },
        {
            id: 3,
            icon: <i class="fa-solid fa-xmark"></i>,
            title: "Builder Tie-ups",
            text: "Genuine builder connections across Gurugram",
        },
        {
            id: 4,
            icon: <i class="fa-solid fa-database"></i>,
            title: "premium Inventory",
            text: "Inventory across all premium & mid segment sectors",
        },
        {
            id: 5,
            icon: <i class="fa-solid fa-users"></i>,
            title: "High-intent leads",
            text: "Buyer and tenant leads that actually convert.",
        },
        {
            id: 6,
            icon: <i class="fa-solid fa-building"></i>,
            title: "Real Closings",
            text: "A platform designed for closing deals,not confusion.",
        },
    ];

    const testimonials = [
        {
            name: "Rahul Sharma",
            role: "Real Estate Broker",
            review:
                "This platform completely changed how I get property leads. Super accurate data and zero fake numbers.",
            image: "https://randomuser.me/api/portraits/men/32.jpg",
        },
        {
            name: "Anita Verma",
            role: "Agent, Gurugram",
            review:
                "Amazing experience! The quality of leads is far better than any other service I used before.",
            image: "https://randomuser.me/api/portraits/women/44.jpg",
        },
        {
            name: "Vikram Singh",
            role: "Independent Broker",
            review:
                "Finally a platform that actually helps brokers instead of wasting our time. Highly recommended!",
            image: "https://randomuser.me/api/portraits/men/40.jpg",
        },
    ];

    const stats = [
        { number: "1200+", label: "Brokers Registered" },
        { number: "10000+", label: "Verified Inventories" },
        { number: "68+", label: "Sectors Covered" },
        { number: "90000+", label: "Daily Searches" },
    ];

    const steps = [
        {
            icon: <i class="fa-solid fa-magnifying-glass"></i>,
            title: "Verified Inventory",
            text: "Premium listings onboarded",
        },
        {
            icon: <i class="fa-regular fa-handshake"></i>,
            title: "Direct Connections",
            text: "Access builders & owners",
        },
        {
            icon: <i class="fa-solid fa-users"></i>,
            title: "Resale Sharing",
            text: "List & explore inventory",
        },
        {
            icon: <i class="fa-solid fa-chart-line"></i>,
            title: "Lead Management",
            text: "Track deals seamlessly",
        },
    ];

    const [index, setIndex] = useState(0);

    const nextSlide = () => {
        setIndex((prev) => (prev + 1) % testimonials.length);
    };

    const prevSlide = () => {
        setIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
    };

    const [isSticky, setIsSticky] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            setIsSticky(window.scrollY > 50);
        };
        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);
    // Auto slide every 4 seconds
    useEffect(() => {
        const timer = setInterval(nextSlide, 10000);
        return () => clearInterval(timer);
    }, []);
    return (
        <div className="citypage_container_blue">
            <div >
                <WinnersHeaderBlue />
            </div>
            {/* <div
                className="hero-premium"
                style={{
                    // backgroundImage: `url(${cityDetails?.firstSection?.image})`,
                    backgroundImage: cityDetails?.firstSection?.image
                        ? `url(${cityDetails.firstSection.image})`
                        : "none",
                }}
            > */}
            {/* <div className="hero-overlay"></div> */}
            {/* 
                <div className="hero-grid city-uni-container">
                    <div className="hero-left">
                        <div className="hero-badge">
                            <span className="hero-badge-dot"></span>
                            {cityDetails?.firstSection?.mainTag}
                        </div>

                        <h1 className="hero-title">
                            {cityDetails?.firstSection?.header
                                ?.split(" ")
                                .slice(0, 2)
                                .join(" ")}

                            <span className="hero-highlight">
                                {" "}
                                {cityDetails?.firstSection?.header
                                    ?.split(" ")
                                    .slice(2, 4)
                                    .join(" ")}
                            </span>

                            {" "}
                            {cityDetails?.firstSection?.header
                                ?.split(" ")
                                .slice(4)
                                .join(" ")}
                        </h1>

                        <p className="hero-description">
                            {cityDetails?.firstSection?.descriptions?.map((e, i) => (
                                <span key={i}>{e} • </span>
                            ))}
                        </p>

                        <div className="hero-actions">
                            <button
                                className="hero-btn-primary"
                                onClick={() => navigate("/profile")}
                            >
                                Register Now
                            </button>

                            <button className="hero-btn-secondary">
                                Learn More
                            </button>
                        </div>


                    </div>

                    <div className="hero-right">
                        <div className="hero-floating-card">
                            <h3>Premium Builder Network</h3>

                            <p>
                                Verified Inventory
                            </p>

                            <p>
                                Direct Owner Data
                            </p>

                            <p>
                                Faster Closings
                            </p>
                        </div>

                        <div className="hero-features">
                            {cityDetails?.firstSection?.tags?.map((e, i) => (
                                <div className="hero-feature-card" key={i}>
                                    <div className="hero-feature-icon">

                                        <img
                                            style={{ height: "30px", width: "30px" }}
                                            src={e?.icon || fallbackIcons3[i]}
                                            alt={e?.header || "icon"}
                                            onError={(e) => {
                                                e.currentTarget.onerror = null;
                                                e.currentTarget.src = fallbackIcons3[i];
                                            }}
                                        />
                                    </div>

                                    <span>{e?.content}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div> */}

            {/* <div
                    className="city-hero-section"
                    data-aos="fade-up"
                    data-aos-duration="1000"
                >
                    <div className="city-hero-content">

                        <div
                            className="city-hero-left"
                            data-aos="fade-right"
                            data-aos-delay="200"
                        >
                            <div className="hero-badge">
                                <span className="hero-badge-dot"></span>
                                {cityDetails?.firstSection?.mainTag}
                            </div>

                            <h1 className="hero-title">
                                {cityDetails?.firstSection?.header
                                    ?.split(" ")
                                    .slice(0, 2)
                                    .join(" ")}

                                <span className="hero-highlight">
                                    {" "}
                                    {cityDetails?.firstSection?.header
                                        ?.split(" ")
                                        .slice(2, 4)
                                        .join(" ")}
                                </span>

                                {" "}
                                {cityDetails?.firstSection?.header
                                    ?.split(" ")
                                    .slice(4)
                                    .join(" ")}
                            </h1>

                            <p className="hero-description">
                                {cityDetails?.firstSection?.descriptions?.map((e, i) => (
                                    <span key={i}>
                                        {e}
                                        <br />
                                    </span>
                                ))}
                            </p>

                            <div className="hero-actions">
                                <button
                                    className="hero-btn-primary"
                                    onClick={() => navigate("/profile")}
                                >
                                    Register Now
                                </button>

                                <button className="hero-btn-secondary">
                                    Learn More
                                </button>
                            </div>
                        </div>

                        <div
                            className="city-hero-right"
                            data-aos="zoom-in"
                            data-aos-delay="400"
                        >
                            <div className="hero-glass-card">

                                <div className="hero-circle"></div>

                                <h3>Premium Builder Network</h3>

                                <p>
                                    Access verified projects, builders, dealer database and property
                                    intelligence from one dashboard.
                                </p>

                            </div>
                        </div>

                    </div>

                    <div
                        className="hero-feature-row"
                        data-aos="fade-up"
                        data-aos-delay="600"
                    >
                        {cityDetails?.firstSection?.tags?.map((e, i) => (
                            <div className="hero-feature-card" key={i}>
                                <div className="hero-feature-icon">
                                    <img
                                        src={e?.icon || fallbackIcons3[i]}
                                        alt=""
                                        onError={(ev) => {
                                            ev.currentTarget.src = fallbackIcons3[i];
                                        }}
                                    />
                                </div>

                                <span>{e?.content}</span>
                            </div>
                        ))}
                    </div>
                </div> */}

            <div className="hero-grid city-uni-container2">
                {/* Background Shapes */}
                <div className="hero-bg-circle hero-bg-circle1"></div>
                <div className="hero-bg-circle hero-bg-circle2"></div>
                <div className="hero-bg-pattern"></div>

                {/* LEFT */}
                <div
                    className="hero-left"
                    data-aos="fade-right"
                    data-aos-duration="900"
                    data-aos-once="false"
                >
                    <div className="hero-badge">
                        <span className="hero-badge-dot"></span>
                        {cityDetails?.firstSection?.mainTag}
                    </div>

                    <h1 className="hero-title">
                        {cityDetails?.firstSection?.header
                            ?.split(" ")
                            .slice(0, 2)
                            .join(" ")}

                        <span className="hero-highlight">
                            {" "}
                            {cityDetails?.firstSection?.header
                                ?.split(" ")
                                .slice(2, 4)
                                .join(" ")}
                        </span>

                        {" "}
                        {cityDetails?.firstSection?.header
                            ?.split(" ")
                            .slice(4)
                            .join(" ")}
                    </h1>

                    <p className="hero-description">
                        {cityDetails?.firstSection?.descriptions?.map((e, i) => (
                            <span key={i}>
                                {e}
                                {i !== cityDetails?.firstSection?.descriptions?.length - 1 && " • "}
                            </span>
                        ))}
                    </p>

                    <div className="hero-actions">
                        <button
                            className="hero-btn-primary"
                            onClick={() => navigate("/profile")}
                        >
                            Register Now
                        </button>

                        <button className="hero-btn-secondary">
                            Learn More
                        </button>
                    </div>

                    {/* Bottom Stats */}
                    {/* <div className="hero-bottom-stats">
                        <div
                            className="hero-stat-card"
                            data-aos="zoom-in"
                            data-aos-delay="100"
                            data-aos-once="false"
                        >
                            <h3>1000+</h3>
                            <p>Verified Leads</p>
                        </div>

                        <div
                            className="hero-stat-card"
                            data-aos="zoom-in"
                            data-aos-delay="200"
                            data-aos-once="false"
                        >
                            <h3>500+</h3>
                            <p>Builders</p>
                        </div>

                        <div
                            className="hero-stat-card"
                            data-aos="zoom-in"
                            data-aos-delay="300"
                            data-aos-once="false"
                        >
                            <h3>24×7</h3>
                            <p>Support</p>
                        </div>
                    </div> */}
               
                </div>

                {/* RIGHT */}
                <div
                    className="hero-right"
                    data-aos="fade-left"
                    data-aos-duration="900"
                    data-aos-once="false"
                >
                    {/* Floating Premium Card */}
                    <div
                        className="hero-floating-card"
                        data-aos="flip-left"
                        data-aos-delay="100"
                        data-aos-once="false"
                    >
                        <div className="hero-floating-top">
                            <div className="hero-floating-icon">
                                <i className="fa-solid fa-building"></i>
                            </div>

                            <div>
                                <h3>Premium Builder Network</h3>
                                <span>Verified Real Estate Ecosystem</span>
                            </div>
                        </div>

                        <div className="hero-check-list">
                            <div>
                                <i className="fa-solid fa-circle-check"></i>
                                Verified Inventory
                            </div>

                            <div>
                                <i className="fa-solid fa-circle-check"></i>
                                Direct Owner Data
                            </div>

                            <div>
                                <i className="fa-solid fa-circle-check"></i>
                                Faster Closings
                            </div>
                        </div>
                    </div>

                    {/* API Features */}
                    <div className="hero-features">
                        {cityDetails?.firstSection?.tags?.map((e, i) => (
                            <div
                                className="hero-feature-card"
                                key={i}
                                data-aos="fade-up"
                                data-aos-delay={i * 100}
                                data-aos-once="false"
                            >
                                {/* <div className="hero-feature-icon">
            <img
              src={e?.icon || fallbackIcons3[i]}
              alt={e?.header || "icon"}
              onError={(ev) => {
                ev.currentTarget.onerror = null;
                ev.currentTarget.src = fallbackIcons3[i];
              }}
            />
          </div> */}

                                <span>{e?.content}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* 2nd */}

            <div className="stats-section">

    <div className="stats-bg-circle stats-left"></div>
    <div className="stats-bg-circle stats-right"></div>

    <div
        className="stats-container city-uni-container2"
        data-aos="fade-up"
        data-aos-duration="900"
    >

        {cityDetails?.seventhSection?.counts?.map((item, index) => (

            <div
                key={index}
                className="stats-card"
                data-aos="zoom-in"
                data-aos-delay={index * 150}
                data-aos-duration="900"
                data-aos-once="false"
            >

                <div className="stats-number">

                    {item?.heading}

                </div>

                {/* <div className="stats-divider"></div> */}

                <p>

                    {item?.subHeading}

                </p>

            </div>

        ))}

    </div>

</div>

            {/* </div> */}
            <div className="spc-wrp-for-city_blue">
                <AdvertisingBanner />
            </div>
            <ExploreTopCitiesBlue />
            {/* <LocationInsig /> */}
            <WinnersInsightsBlue />

            {/* <div className="problems-section_blue">
                <div className="problem_div_blue">
                    <h2 className="main-title_blue">

                        <span>
                            {cityDetails?.fourthSection?.heading
                                ?.split(" ")
                                .slice(0, 4)
                                .join(" ")}{" "}
                        </span>
                        {cityDetails?.fourthSection?.heading
                            ?.split(" ")
                            .slice(4).join(" ")}

                    </h2>
                    <p className="subtitle_blue">
                        {cityDetails?.fourthSection?.subHeading}
                    </p>
                    <div className="problemscards_sec_blue">
                        {cityDetails?.fourthSection?.sections?.map((item, index) => (
                            <div key={item.id} className="problem-card_blue">
                                <div className="icon_blue">
                                  
                                    <img
                                        style={{ height: "30px", width: "30px" }}
                                        src={item?.icon || fallbackIcons[index]}
                                        alt={item?.header || "icon"}
                                        onError={(e) => {
                                            e.currentTarget.onerror = null;
                                            e.currentTarget.src = fallbackIcons[index];
                                        }}
                                    />
                                </div>
                                <div className="problem_para_blue">
                                    <h4>{item?.header}</h4>
                                    <p>{item?.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div> */}
            <section className="problem-section">

                {/* Background */}

                <div className="problem-bg-circle circle-one"></div>
                <div className="problem-bg-circle circle-two"></div>
                <div className="problem-grid"></div>

                <div className="problem-container">

                    {/* Heading */}

                    <div
                        className="problem-heading"
                        data-aos="fade-up"
                        data-aos-duration="900"
                    >
                        <div className="problem-badge">

                            <AlertTriangle size={15} />

                            <span>THE REAL CHALLENGES</span>

                        </div>

                        <h2>

                            <span>

                                {cityDetails?.fourthSection?.heading
                                    ?.split(" ")
                                    .slice(0, 4)
                                    .join(" ")}

                            </span>

                            {" "}

                            {cityDetails?.fourthSection?.heading
                                ?.split(" ")
                                .slice(4)
                                .join(" ")}

                        </h2>

                        <p>

                            {cityDetails?.fourthSection?.subHeading}

                        </p>
                    </div>

                    {/* Cards */}

                    <div className="problem-card-grid">

                        {cityDetails?.fourthSection?.sections?.map((item, index) => (

                            <div
                                key={item.id || index}
                                className="problem-card"
                                data-aos="fade-up"
                                data-aos-delay={index * 120}
                            >

                                {/* Card Number */}

                                <div className="problem-number">
                                    {(index + 1).toString().padStart(2, "0")}
                                </div>

                                {/* Icon */}
                                {/* 
              <div className="problem-icon">

                <img
                  src={item?.icon || fallbackIcons2[index]}
                  alt={item?.header || "icon"}
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = fallbackIcons2[index];
                  }}
                />

              </div> */}

                                {/* Content */}

                                <div className="problem-content">

                                    <h4>

                                        {item?.header}

                                    </h4>

                                    <p>

                                        {item?.desc}

                                    </p>

                                </div>

                                {/* Bottom Line */}

                                <span className="problem-line"></span>

                            </div>

                        ))}

                    </div>

                </div>

            </section>

            {/* 6th section start */}
            <div className="problems-section2_blue">
                <h2 className="main-title22_blue">
                    {cityDetails?.fifthSection?.heading}
                </h2>
                <p className="subtitle22_blue">
                    {cityDetails?.fifthSection?.desc}
                </p>
                <div className="problemscards_sec_blue">
                    {cityDetails?.fifthSection?.sections?.map((item, index) => (
                        <div key={item.id} className="problem-card22_blue">
                            <div className="icon_blue">
                                {/* <img
                                    style={{ height: "30px", width: "30px" }}
                                    src={item?.icon}
                                    alt=""
                                /> */}
                                <img
                                    style={{ height: "30px", width: "30px" }}
                                    src={item?.icon || fallbackIcons2[index]}
                                    alt={item?.header || "icon"}
                                    onError={(e) => {
                                        e.currentTarget.onerror = null;
                                        e.currentTarget.src = fallbackIcons2[index];
                                    }}
                                />
                            </div>
                            <div className="problem_para22_blue">
                                <h4>{item?.heading}</h4>
                                <p>{item?.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* 7th section start */}
            {/* <div className="stats-container_blue">
                    {cityDetails?.seventhSection?.counts?.map((item, index) => (
                        <div key={index} className="stat-box_blue">
                            <h2>{item?.heading}</h2>
                            <p>{item?.subHeading}</p>
                        </div>
                    ))}
                </div> */}
            {/* <div className="howitworks-section_blue">
                <div className="how-content_blue">
                    <div className="contant_title_blue">
                        <h2 className="titleh2_blue">
                            {cityDetails?.seventhSection?.midHeading}
                        </h2>
                        <p className="subtitle_blue">
                            {cityDetails?.seventhSection?.midSubHeading}
                        </p>
                    </div>

                    <div className="steps-container_blue">
                        {cityDetails?.seventhSection?.works?.map((step, index) => (
                            <div key={index} className="step-card_blue">
                                <div className="step-icon_blue">
                                    <img
                                        style={{ height: "30px", width: "30px" }}
                                        src={step?.icon || fallbackIcons3[index]}
                                        alt={step?.header || "icon"}
                                        onError={(e) => {
                                            e.currentTarget.onerror = null;
                                            e.currentTarget.src = fallbackIcons3[index];
                                        }}
                                    />
                                </div>
                                <h4>{step?.heading}</h4>
                                <p>{step?.subheading}</p>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="gurgaon-lead_blue">
                    <div className="gurgaon-under_blue">
                        <div className="gurgaon-under_left_blue">
                            <div
                                className="gargaon_card1_blue"
                                style={{
                                    background: cityDetails?.thirdSection?.image
                                        ? `linear-gradient(to bottom, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.8)), url(${cityDetails?.thirdSection?.image}) center/cover no-repeat`
                                        : "var(--ws-blue-primary)",
                                }}
                            >
                                <h2>Since 2000</h2>
                                <p>serving the Industry</p>
                            </div>
                        </div>
                        <div className="gurgaon-under_right_blue">
                            <div className="garga_h2_blue">
                                <h2 className="garga_h2_h2_blue">
                                    <span>
                                        {cityDetails?.thirdSection?.heading
                                            ?.split(" ")
                                            .slice(0, 2)
                                            .join(" ")}{" "}
                                    </span>
                                    {cityDetails?.thirdSection?.heading
                                        ?.split(" ")
                                        .slice(2)
                                        .join(" ")}
                                </h2>
                                <div className="garga_para_blue">
                                    <p>{cityDetails?.thirdSection?.desc}</p>
                                </div>
                                <div className="garga_list_blue">
                                    {cityDetails?.thirdSection?.points?.map((e, i) => {
                                        return (
                                            <p key={i} className="garga_list_p_blue">
                                                <img
                                                    style={{ height: "20px", width: "20px" }}
                                                    alt={i}
                                                    src={e?.icon}
                                                />{" "}
                                                {e?.content}
                                            </p>
                                        );
                                    })}
                                </div>
                            </div>
                            <button
                                onClick={() => {
                                    navigate("/aboutus");
                                }}
                                className="gargabtn_blue"
                            >
                                Learn More About Us
                            </button>
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="process-main-section">

                {/* Background */}
                <div className="process-bg-circle circle-left"></div>
                <div className="process-bg-circle circle-right"></div>

                {/* ===========================
      PROCESS SECTION
  ============================ */}

                <section className="process-section">

                    <div
                        className="process-heading"
                        data-aos="fade-up"
                        data-aos-duration="900"
                    >
                        <span className="process-badge">
                            HOW IT WORKS
                        </span>

                        <h2>

                            {cityDetails?.seventhSection?.midHeading}

                        </h2>

                        <p>

                            {cityDetails?.seventhSection?.midSubHeading}

                        </p>

                    </div>

                    {/* Timeline */}

                    <div className="timeline-wrapper">

                        {/* Animated Line */}

                        <div className="timeline-line"></div>

                        <div className="timeline-grid">

                            {cityDetails?.seventhSection?.works?.map((step, index) => (

                                <div
                                    key={index}
                                    className="timeline-item"
                                    data-aos="zoom-in-up"
                                    data-aos-delay={index * 150}
                                    data-aos-duration="900"
                                >

                                    {/* Circle */}

                                    <div className="timeline-circle">

                                        <img
                                            src={step?.icon || fallbackIcons3[index]}
                                            alt={step?.heading}
                                            onError={(e) => {
                                                e.currentTarget.onerror = null;
                                                e.currentTarget.src = fallbackIcons3[index];
                                            }}
                                        />

                                    </div>

                                    {/* Number */}

                                    <div className="timeline-number">

                                        {(index + 1).toString().padStart(2, "0")}

                                    </div>

                                    {/* Card */}

                                    <div className="timeline-card">

                                        <h4>

                                            {step?.heading}

                                        </h4>

                                        <p>

                                            {step?.subheading}

                                        </p>

                                    </div>

                                </div>

                            ))}

                        </div>

                    </div>

                </section>

                {/* ===========================
      ABOUT SECTION
  ============================ */}

                <section className="about-company-section">

                    <div className="about-company-grid">

                        {/* Left */}

                        <div
                            className="about-image-side"
                            data-aos="fade-right"
                        >
                            <div
                                className="about-image-card"
                                style={{
                                    background: cityDetails?.thirdSection?.image
                                        ? `
        linear-gradient(rgba(0,0,0,.45), rgba(0,0,0,.70)),
        url(${logo}) center / 260px no-repeat,
        url(${cityDetails?.thirdSection?.image}) center/cover no-repeat
      `
                                        : `
        linear-gradient(rgba(0,0,0,.35), rgba(0,0,0,.65)),
        url(${logo}) center / 260px no-repeat,
        var(--ws-blue-primary)
      `,
                                }}
                            >

                                <div className="experience-box">

                                    <h2>

                                        Since 2000

                                    </h2>

                                    <span>

                                        Serving The Industry

                                    </span>

                                </div>

                                <div className="floating-badge">

                                    Trusted Brand

                                </div>

                            </div>

                        </div>

                        {/* Right */}

                        <div
                            className="about-content-side"
                            data-aos="fade-left"
                        >

                            {/* <span className="about-tag">

                                ABOUT US

                            </span> */}

                            <h2>

                                <span>

                                    {cityDetails?.thirdSection?.heading
                                        ?.split(" ")
                                        .slice(0, 2)
                                        .join(" ")}

                                </span>

                                {" "}

                                {cityDetails?.thirdSection?.heading
                                    ?.split(" ")
                                    .slice(2)
                                    .join(" ")}

                            </h2>

                            <p className="about-description">

                                {cityDetails?.thirdSection?.desc}

                            </p>

                            <div className="about-points">

                                {cityDetails?.thirdSection?.points?.map((item, i) => (

                                    <div
                                        className="about-point"
                                        key={i}
                                        data-aos="fade-up"
                                        data-aos-delay={i * 100}
                                    >

                                        <div className="point-icon">

                                            <img
                                                src={item?.icon}
                                                alt=""
                                            />

                                        </div>

                                        <span>

                                            {item?.content}

                                        </span>

                                    </div>

                                ))}

                            </div>

                            <div className="about-actions">

                                <button
                                    className="about-btn"
                                    onClick={() => {
                                        navigate("/aboutus");
                                    }}
                                >

                                    Learn More

                                </button>

                            </div>

                        </div>

                    </div>

                </section>

            </div>

            {/* 8th section start */}
            <DownloadApp />
            {/* footer section */}
            <div className="footer-section_blue">
                <div className="footer-cta_blue">
                    <h2>{cityDetails?.ninethSection?.heading}</h2>
                    <p>{cityDetails?.ninethSection?.desc}</p>

                    <button
                        className="register-btn_blue"
                        onClick={() => {
                            navigate("/profile");
                        }}
                        data-aos="fade-left"
                    >
                        Register Now
                    </button>
                </div>
            </div>
        </div>
    )
}

export default NewCItypage